import {Component, OnInit, ViewChild} from '@angular/core';
import {ExcTranslation} from 'exc-core';
import {ExcRestService} from 'exc-rest';
import {ExcListConfig} from 'exc-controls';

@Component({
  selector: 'app-provider-dashboard',
  templateUrl: './provider-dashboard.component.html',
  styles: []
})
export class ProviderDashboardComponent extends ExcTranslation implements OnInit {
  @ViewChild('popup') popup;
  data: {Auditors: any[], AuditorsSum: {}, Planning: any[], PlanningSum: {}, LastMonth: any[]}
  = {Auditors: [], Planning: [], PlanningSum: {}, AuditorsSum: {}, LastMonth: []};
  selection: {Year: number, Month: number} = {Year: (new Date()).getFullYear() , Month: (new Date()).getMonth() + 1};
  popupData: {Year: number, Month: number} = {Year: (new Date()).getFullYear() , Month: (new Date()).getMonth() + 1};
  popupOptions: {Month: any[], Year: any[]}  = {Month: [], Year: []};
  isLoading = false;
  monthTableConfig: ExcListConfig = new ExcListConfig();
  premonthTableConfig: ExcListConfig = new ExcListConfig();
  auditorTableConfig: ExcListConfig = new ExcListConfig();
  constructor(private excRest: ExcRestService) {
    super();
    const _self = this;
    this.monthTableConfig.selectionMode = 'none';
    this.premonthTableConfig.selectionMode = 'none';
    this.auditorTableConfig.selectionMode = 'none';
    for (let i = 1; i <= 12; i++) {
      _self.popupOptions.Month.push({text: i, value: i});
    }
    for (let i = -3; i <= 0; i++) {
      _self.popupOptions.Year.push({text: (new Date()).getFullYear() + i, value: (new Date()).getFullYear() + i});
    }
  }

  ngOnInit() {
    this.initialLoad();
  }
  initialLoad() {
    const _self = this;
    _self.isLoading = true;
    const url = _self.excRest.computeUrl('Provider_DashboardR_Summary', {month: _self.selection.Month, year: _self.selection.Year});
    _self.excRest.get(url, {}).subscribe(ret => {
        Object.assign(_self.data, ret);
        _self.isLoading = false;
    });
  }
  cancelPopup(e) {
    const _self = this;
    _self.popup.hide(e);
  }

  applyPopup(e) {
    const _self = this;
    _self.popup.hide(e);
    _self.selection.Year = this.popupData.Year;
    _self.selection.Month = this.popupData.Month;
    _self.initialLoad();
  }
  showPopup(e) {
    const _self = this;
    _self.popup.show(e);
  }
  replaceNullValues(value) {
    if (value === null || value === undefined) {
      return '-';
    } else {
      return value;
    }
}
}
